const REMOTE_URL = 'https://api.nairotube.com/ntv';

// Production is the safe default. Local development must opt in explicitly with
// REACT_APP_SERVER_URL=http://localhost:8000/ntv.
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || REMOTE_URL;
